import {showModalIframe} from "../../../../core/utils/modal";

export class DebugInfo {
	_searchCriteria = '';

	getSearchCriteria() {
		return this._searchCriteria;
	}

	setSearchCriteria(criteria) {
		this._searchCriteria = criteria;
	}

	show(itemType, itemId) {
		if (!this._searchCriteria) {
			return;
		}
		showModalIframe('shop_search_debug', {
			criteria: this._searchCriteria,
			item_type: itemType,
			item_id: itemId
		});
	}
}


// WEBPACK FOOTER //
// ./modules/shop/common/model/debuginfo.js